<template>
    <div class="cloud-container">
        <!-- Banner -->
        <CommonComponentsProductsCloudSwipper />
        <div class="global-limited-1360px-container">
            <!-- <CommonComponentsProductsCloudSwipper /> -->

            <!-- 1 -->
            <CommonComponentsProductsCloudThreeVideo />
            <!-- 2 -->
            <!-- 3 -->
        </div>
        <CommonComponentsProductsCloudExhibit />
    </div>
</template>

<script setup lang="ts">
    import { ifCNLocale } from '~~/composables/useLocale.ts';
    const isCN = ifCNLocale();
</script>

<style lang="less" scoped>
    .cloud-container {
        background-color: #000000;
        width: 100%;
        color: #fff;
    }
</style>
